import React, {useEffect, useMemo, useState} from 'react';
import {useCookies} from 'react-cookie';

import classes from './AISearchToggle.module.pcss';
import Input from 'js/components/Common/FormComponents/Input/Input';
import SearchStore from 'js/store/SearchStore';
import {observer} from 'mobx-react';
import Heading from 'js/components/Common/Heading/Heading';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import fetchData from 'js/components/Common/Header/TranslateSelector/fetchData';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';

const AISearchToggle = () => {
    const [infoTitle, setInfoTitle] = useState('');
    const [infoDescription, setDescription] = useState('');
    const [cookies, setCookie] = useCookies([]);

    const {REACT_APP_AI_SEARCH_COOKIE} = process.env || {};
    const {isAISearch} = SearchStore;

    const cookieOption = useMemo(() => (
        {
            path: '/',
            domain: `.${location.hostname}`,
            maxAge: 315360000
        }
    ), []);

    useEffect(() => {
        const storedValue = cookies[REACT_APP_AI_SEARCH_COOKIE];
        SearchStore.setIsAISearch(storedValue === true || storedValue === 'true');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useFetchData({
        query: `${fetchData}`,
        condition: true,
        updateData: (data) => {
            setInfoTitle(data?.themeGeneralSettings?.Options?.searchDisclaimer?.title);
            setDescription(data?.themeGeneralSettings?.Options?.searchDisclaimer?.description);
        }
    });

    return (
        <>
            <div className={`${classes.AISearchToggle} ${!SearchStore.isAISearch ? classes.Disabled : ''}`}>
                <span>AI</span>
                <Input type="checkbox"
                       slug={'aiSearchToggle'}
                       id={'aiSearchToggle'}
                       withLabel={true}
                       slideCheckbox={true}
                       checked={SearchStore.isAISearch}
                       slideCheckboxType={'Big'}
                       slideCheckboxColorType={'Blue'}
                       onChange={async () => {
                           SearchStore.setIsAISearch();
                           setCookie(REACT_APP_AI_SEARCH_COOKIE, SearchStore.isAISearch, {...cookieOption});
                           await MixPanelWrapper.TrackEvent(
                               'AI Toggle is Selected',
                               {
                                   category: 'Search Input',
                                   value: !isAISearch ? 'on' : 'off'
                               });
                       }}
                />
            </div>
            <DataValidator data={infoTitle?.length > 0 && infoDescription?.length}>
                <section className={classes.AISearchToggleInfo}>
                    <Heading text={infoTitle} type={'h6'}/>
                    <p>{infoDescription}</p>
                </section>
            </DataValidator>
        </>
    );
};

export default observer(AISearchToggle);
